"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../../../zustandStore");
const banner_1 = require("../common/banner");
const title_1 = require("../common/title");
const authForm_1 = __importDefault(require("./authForm"));
const passwordLogin_1 = __importDefault(require("./passwordLogin/passwordLogin"));
const ssoLogin_1 = __importDefault(require("./ssoLogin"));
const lexico = new lexico_1.default();
const LoginForm = () => {
    const theme = (0, material_1.useTheme)();
    const auth = (0, zustandStore_1.useZustand)(state => state.auth);
    const location = (0, react_router_1.useLocation)();
    const jsParams = new URLSearchParams(globalThis.location.search);
    const reactParams = new URLSearchParams(location.search);
    const isPlatformUser = jsParams.has('isPlatformUser') || reactParams.has('isPlatformUser');
    const TitleComp = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? title_1.HbscTitle : title_1.Title;
    return ((0, jsx_runtime_1.jsx)(authForm_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Container, { style: {
                width: '360px',
                padding: 0,
                border: `1px solid ${theme.palette.tsGoColor.grayLightest}`,
                backgroundColor: theme.palette.tsGoColor.white,
                marginTop: theme?.tsGoUnit.tsUnitHalf,
            }, children: [(0, jsx_runtime_1.jsx)(banner_1.Banner, { className: "banner signin" }), (0, jsx_runtime_1.jsx)(TitleComp, { children: isPlatformUser
                        ? lexico.tr('Sign in with your existing \n\n Tradeshift credentials')
                        : lexico.tr('Authentication') }), auth.login.isPasswordLogin && (0, jsx_runtime_1.jsx)(passwordLogin_1.default, {}), auth.login.isSSOLogin && (0, jsx_runtime_1.jsx)(ssoLogin_1.default, {})] }) }));
};
exports.default = LoginForm;
